// Brand logos map — restaurant/store id → logo URL.
// Unknown/missing brands fall back to initials SVG in RestaurantCard.

export const BRAND_LOGOS = {
  // Bahrah stores — user-provided logos
  rest_offers_hall: "/api/files/jayek/restaurants/4b142295-88f2-4183-9098-14655d1e9731.png",
  rest_einayati: "/api/files/jayek/logos/einayati-card-v2.png",
};
